module.exports = __webpack_public_path__ + "img/3Shape3.521b6053.png";